import { initFancybox } from "@solvari/components";

import "./reviewDetailed.css";
import "@solvari/components/blade/review/review-widget/reviewScore.css";

initFancybox();
